//import './wdyr';  // Debug render react 
import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import 'react-dates/initialize';

import { ToastProvider } from 'react-toast-notifications';

import App from './App';
// import ExempleCheckableDropdown from './ExempleCheckableDropdown';

import * as serviceWorker from './serviceWorker';
import configureStore from './store/configureStore';
import AppListView from './AppListView';

// import './styleWrapper.less';
const store = configureStore();

// window.webdev = true;

if (window.webdev && process.env.NODE_ENV === 'development') {
  // Si on est en dev ici, on fake que webdev a fini de charger sa page
  setTimeout(() => {
    window.affichageDefaut = {
      type: 'Semaine',
      mode : 'horizontal',
      // date: '2022-10-03',
      // salles: [7]
    }
  }, 3000)
}

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <ToastProvider portalTargetSelector='#JVS_publication_ligne'>
        <App />
      </ToastProvider>
      {/* <AppListView /> */}
      {/* <ExempleCheckableDropdown /> */}
    </React.StrictMode>
  </Provider>,
  document.getElementById('globalContainer')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
